module.exports = __webpack_public_path__ + "models/thermo_7f39659ffc7dc5a845306850a6ac0844.glb";